// extracted by mini-css-extract-plugin
export default {"wrap":"ThemeToggle_wrap__9w9EO","label":"ThemeToggle_label__kt4di","seg":"ThemeToggle_seg__k4kVZ","opt":"ThemeToggle_opt__Y-cn4","active":"ThemeToggle_active__xL0cW"};